export function createLookupMap<T>(
    bundleOfferIds: Array<string>,
    func: (x0: string) => T | undefined | null
): {
    [x: string]: T | undefined | null;
} {
    return bundleOfferIds.reduce((accumulatedObject, id) => {
        accumulatedObject[id] = func(id);
        return accumulatedObject;
    }, {} as { [k: string]: T | undefined | null });
}
